<!-- table start here -->
<div class="margin-top-10 margin-bottom-5 button-row text-right">
	<button
		mat-fab
		*ngIf="isSystemicManager"
		color="primary"
		aria-label="Notes"
		matTooltip="Notes"
		appAnnounceTooltip="Notes"
		class="mat-floating-button notes-icon"
		appDebounceClick
		id="sys-dtl-openNotesDialog"
		(debounceClick)="openNotesDialog()"
	>
		<mat-icon>chat_bubble</mat-icon>
	</button>
	<mat-checkbox
		*ngIf="isSystemicManager && !isSystemicModule"
		fxFlex="nogrow"
		aria-label="Checkbox to select all cases"
		class="master-checkbox-offset"
		(change)="masterToggle($event)"
		[checked]="selection.selected.length === systemicCaseCharges?.length && selection.selected.length > 0"
		[indeterminate]="selection.selected.length > 0 && selection.selected.length < systemicCaseCharges?.length"
		id="master-toogle"
	>
		{{ selection.selected.length }} of {{ systemicCaseCharges?.length }} Selected
	</mat-checkbox>
	<button
		*ngIf="isSystemicManager"
		mat-flat-button
		color="primary"
		id="assign-button"
		[disabled]="!modified"
		class="mat-button-sm margin-right-20"
		appDebounceClick
		(debounceClick)="save()"
	>
		SAVE
	</button>
	<button
		fxFlex="nogrow"
		*ngIf="isSystemicManager && !isSystemicModule"
		mat-flat-button
		color="primary"
		id="assign-button"
		class="mat-button-sm margin-right-20"
		[disabled]="selection.selected.length === 0"
		appDebounceClick
		(debounceClick)="removeAll()"
	>
		REMOVE
	</button>
</div>
<div role="status" class="sr-only" aria-live="polite">{{ ariaResultAlert }} results found</div>
<div [style.overflow]="'auto'">
	<mat-table style="width:100%;display: table;" [dataSource]="dataSource" matSort appAnnounceSortChange>
		<ng-container matColumnDef="select">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row">
				<mat-checkbox
					attr.aria-label="Check box to select the {{ row.caseDetail?.ciChargeNumber }} case"
					class="margin-right-5"
					id="sys-dtl-checkbox-selected"
					(click)="$event.stopPropagation()"
					(change)="selection.toggle(row)"
					[checked]="selection.isSelected(row)"
				>
				</mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="ciChargeNumber">
			<th mat-header-cell *matHeaderCellDef aria-label="EEOC Number">
				<div mat-sort-header sortActionDescription="Sort by EEOC number">EEOC Number</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-eeoc-number"
					(keyup)="applyColumnFilter($event.target.value, 'ciChargeNumber')"
					aria-label="Filter by EEOC Number"
				/>
			</th>
			<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
			<th mat-cell *matCellDef="let row" class="lead-col mat-mdc-cell">
				<a class="m-focus" appDebounceClick (debounceClick)="caseSelected(row.caseDetail)">
					{{ row.caseDetail?.ciChargeNumber }}
				</a>
			</th>
		</ng-container>

		<ng-container matColumnDef="rspName">
			<th mat-header-cell *matHeaderCellDef aria-label="Respondent">
				<div mat-sort-header sortActionDescription="Sort by respondent">Respondent</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-respondent"
					(keyup)="applyColumnFilter($event.target.value, 'rspName')"
					aria-label="Filter by Respondent"
				/>
			</th>
			<td mat-cell *matCellDef="let row">{{ row.caseDetail?.rspName }}</td>
		</ng-container>

		<ng-container matColumnDef="createdOn">
			<th mat-header-cell *matHeaderCellDef aria-label="Date Added">
				<div mat-sort-header sortActionDescription="Sort by date added">Date Added</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-date-added"
					(keyup)="applyColumnFilter($event.target.value, 'createdOn')"
					aria-label="Filter by Date Added"
				/>
			</th>
			<td mat-cell *matCellDef="let row">{{ cmnServ.displayEsttoLocale(row.createdOn) }}</td>
		</ng-container>

		<ng-container matColumnDef="alStatuteShortName">
			<th mat-header-cell *matHeaderCellDef aria-label="Statute">
				<div mat-sort-header sortActionDescription="Sort by statute">Statute</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-statute"
					(keyup)="applyColumnFilter($event.target.value, 'alStatuteShortName')"
					aria-label="Filter by Statute"
				/>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row.caseDetail, 'alStatuteShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="alBasisShortName">
			<th mat-header-cell *matHeaderCellDef aria-label="Basis">
				<div mat-sort-header sortActionDescription="Sort by basis">Basis</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-basis"
					(keyup)="applyColumnFilter($event.target.value, 'alBasisShortName')"
					aria-label="Filter by Basis"
				/>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row.caseDetail, 'alBasisShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="alIssueShortName">
			<th mat-header-cell *matHeaderCellDef aria-label="Issue">
				<div mat-sort-header sortActionDescription="Sort by issue">Issue</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-issue"
					(keyup)="applyColumnFilter($event.target.value, 'alIssueShortName')"
					aria-label="Filter by Issue"
				/>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row.caseDetail, 'alIssueShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="pchpAssessments">
			<th mat-header-cell *matHeaderCellDef aria-label="PCHP">
				<div mat-sort-header sortActionDescription="Sort by PCHP">PCHP</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-pchp"
					(keyup)="applyColumnFilter($event.target.value, 'pchpAssessments')"
					aria-label="Filter by PCHP"
				/>
			</th>
			<td mat-cell *matCellDef="let row">{{ displayPCHPAssessments(row.caseDetail) }}</td>
		</ng-container>

		<ng-container matColumnDef="ciAcctOfficeDescription">
			<th mat-header-cell *matHeaderCellDef aria-label="Accountable Office">
				<div mat-sort-header sortActionDescription="Sort by accountable office">Accountable Office</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-accountable-office"
					(keyup)="applyColumnFilter($event.target.value, 'ciAcctOfficeDescription')"
					aria-label="Filter by Accountable Office"
				/>
			</th>
			<td mat-cell *matCellDef="let row">{{ row.caseDetail?.ciAcctOfficeDescription }}</td>
		</ng-container>

		<ng-container matColumnDef="chargeAssignments">
			<th mat-header-cell *matHeaderCellDef aria-label="Assigned to">
				<div mat-sort-header sortActionDescription="Sort by assigned to">Assigned to</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-assigned-to"
					(keyup)="applyColumnFilter($event.target.value, 'chargeAssignments')"
					aria-label="Filter by Assigned to"
				/>
			</th>
			<td mat-cell *matCellDef="let row">{{ displayAssignedTo(row.caseDetail) }}</td>
		</ng-container>

		<ng-container matColumnDef="coordinationStatus">
			<th mat-header-cell *matHeaderCellDef aria-label="Systemic status">
				<div mat-sort-header sortActionDescription="Sort by systemic status">Systemic Status</div>
				<input
					(click)="$event.stopPropagation()"
					id="column-filter-systemic-status"
					(keyup)="applyColumnFilter($event.target.value, 'coordinationStatus')"
					aria-label="Filter by Systemic Status"
				/>
			</th>
			<td mat-cell *matCellDef="let row; let i = index">
				<mat-form-field class="input-full-width align mt-2" appearance="outline">
					<mat-label> Coordination Status </mat-label>
					<mat-select
						[(ngModel)]="row.coordinationStatusCode"
						(ngModelChange)="modified = true"
						id="coordinationStatusCode{{ i }}"
						aria-label="Coordination Status {{
							row.coordinationStatusCode
								? 'list box with ' +
								  getDescriptionByValue(row.coordinationStatusCode, coordinationStatus) +
								  ' value selected'
								: ''
						}}"
					>
						<mat-option *ngFor="let item of coordinationStatus" [value]="item.code">
							{{ item.description }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef style="width: 70px" class="pull-text-right" aria-label="Action">Action</th>
			<td mat-cell *matCellDef="let row" class="pull-text-right">
				<button
					mat-icon-button
					color="primary"
					[matMenuTriggerFor]="menu"
					(click)="$event.stopPropagation()"
					matTooltip="Actions"
					appAnnounceTooltip="Actions"
				>
					<mat-icon>more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item appDebounceClick (debounceClick)="removeFromSystemic(row)" id="sys-dtl-remove-btn">Remove</button>
				</mat-menu>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
		<tr
			class="mat-table-row"
			mat-row
			*matRowDef="let row; columns: displayColumns"
			[ngClass]="{ 'mat-table-row-selected': selection.isSelected(row) }"
			appDebounceClick
			(debounceClick)="selection.toggle(row)"
		></tr>
	</mat-table>
</div>
<div
	*ngIf="systemicCaseCharges && systemicCaseCharges.length === 0"
	class="margin-left-20 margin-top-10 margin-bottom-10"
>
	No records found.
</div>
<mat-paginator [pageSizeOptions]="[25, 50, 75, 100, 150]" [showFirstLastButtons]="true" [pageSize]="25"  id="sys-dtl-paginator"></mat-paginator>
